import { GPS } from "../../util/geo";

export type Voorziening = {
  name: string;
  /** OSM tag value, e.g. "supermarket", "school", "restaurant". */
  kind: string;
  distanceM: number;
};

/**
 * Fetch nearby OpenStreetMap "voorzieningen" (POIs) around a [lng, lat] center,
 * via our backend OSM endpoint. Results are pre-filtered to relevant
 * amenity/shop/leisure/tourism tags and sorted by distance.
 */
async function voorzieningen(center: GPS): Promise<Voorziening[]> {
  const response = await fetch(`/api/voorzieningen?c=${center[0]},${center[1]}`);
  if (!response.ok) throw new Error(`HTTP status ${response.status}`);
  return response.json();
}

export const OSMService = { voorzieningen };
